import { z } from 'zod';

/** Site où le processus est placé sur la cartographie (lien `structure_links`). */
export const processLinkedSiteDtoSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  structureLinkId: z.string().uuid(),
});

export const processDtoSchema = z.object({
  id: z.string().uuid(),
  companyId: z.string().uuid(),
  groupProcessId: z.string().uuid(),
  name: z.string(),
  description: z.string().nullable(),
  active: z.boolean(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
  /** Sites sur lesquels une tuile processus existe pour ce processus. */
  linkedSites: z.array(processLinkedSiteDtoSchema),
  /** Nombre de lignes `items` (fiches) rattachées ; suppression du processus refusée si positif. */
  itemsCount: z.number().int().nonnegative(),
});

export const processCreateSchema = z.object({
  groupProcessId: z.string().uuid(),
  name: z.string().min(1).max(255),
  description: z.string().max(255).optional(),
  active: z.boolean().optional(),
});

export const processUpdateSchema = z.object({
  groupProcessId: z.string().uuid().optional(),
  name: z.string().min(1).max(255).optional(),
  description: z.string().max(255).nullable().optional(),
  active: z.boolean().optional(),
});

export const processListQuerySchema = z.object({
  groupProcessId: z.string().uuid().optional(),
});

export type ProcessDto = z.infer<typeof processDtoSchema>;
export type ProcessCreateInput = z.infer<typeof processCreateSchema>;
export type ProcessUpdateInput = z.infer<typeof processUpdateSchema>;
export type ProcessListQuery = z.infer<typeof processListQuerySchema>;
